export default __webpack_public_path__ + "static/media/copy-solid.c96eb253.svg";